module.exports = __webpack_public_path__ + "img/mute.5f7984e.svg";